import axios from 'axios';
import { GET_PROFILE, PROFILE_LOADING, UPDATE_PROFILE, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAIL, USER_LOADED } from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getProfile = (userId = null) => (dispatch, getState) => {
  dispatch(setProfileLoading());
  
  // If userId is provided, fetch that user's profile, otherwise use lightweight own-profile endpoint
  const endpoint = userId ? `/api/users/${userId}` : '/api/users/userprofile';
  
  axios
    .get(endpoint, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status));
    });
};

export const updateProfile = (profileData) => (dispatch, getState) => {
  dispatch({ type: UPDATE_PROFILE });
  
  axios
    .put('/api/users/updateprofile', profileData, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PROFILE_SUCCESS,
        payload: res.data
      });
      // Also update the auth user state to reflect profile changes
      dispatch({
        type: USER_LOADED,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch(returnErrors(err.response?.data, err.response?.status, 'UPDATE_PROFILE_FAIL'));
      dispatch({
        type: UPDATE_PROFILE_FAIL,
        payload: err.response?.data
      });
    });
};

export const setProfileLoading = () => {
  return {
    type: PROFILE_LOADING
  };
}; 
